import dataBase from '../dataBase/database'
// import axios from 'axios'
import { projectService } from './project.service' 
import { networkService } from './network.service'
import { tradepointService } from './tradepoint.service'
import { categoryService } from './category.service'
import { productService } from './product.service'
import { config } from '@/_helpers'
import { reportService } from './report.service'
import store from '../store'
export default {
  async prefetchAll() {
    if (store.state.user.offlineMode) return
    try {
      const data = await reportService.getAllData()

      const projectIds = [...new Set(data.points.map(p => Number(p.projectId)))]
      
      for (const projectId of projectIds) {
        await dataBase.networks.where('projectId').equals(projectId).delete()

        const oldPoints = await dataBase.points.where('projectId').equals(projectId).toArray()
        for (const point of oldPoints) {
          const pointReport = await dataBase.pointReport.where('pointId').equals(String(point.id)).first()
          if(pointReport) {
            await dataBase.photos.where('pointId').equals(String(point.id)).delete()
            await dataBase.pointReport.where('pointId').equals(String(point.id)).delete()
          }
          
          const motivationalReport = await dataBase.motivationalReport.where('pointId').equals(Number(point.id)).first()
          if(motivationalReport && new Date(motivationalReport.createdAt).getMonth() == new Date().getMonth()) {
            await this.deleteMotivationalDmp(motivationalReport.id)
            await dataBase.motivationalReport.where('pointId').equals(Number(point.id)).delete()
          }
          await dataBase.categories.where('pointId').equals(Number(point.id)).delete()
          await dataBase.products.where('pointId').equals(String(point.id)).delete()
          await dataBase.productReportData.where('pointId').equals(String(point.id)).delete()
        }
        await dataBase.points.where('projectId').equals(projectId).delete()
      }

      await dataBase.networks.bulkPut(
        data.networks.map(item => ({
          ...item.network,
          projectId: Number(item.projectId),
          synced: 2,
          cachedAt: new Date().toISOString()
        }))
      )

      await dataBase.points.bulkPut(
        data.points.map(p => ({
          ...p.point,
          synced: 2,
          projectId: Number(p.projectId),
          networkId: Number(p.networkId),
          cachedAt: new Date().toISOString()
        }))
      )

      await dataBase.categories.bulkPut(
        data.categories.map(cat => ({
          ...cat,
          pointId: Number(cat.pointId),
          synced: 2,
          cachedAt: new Date().toISOString()
        }))
      )

      await dataBase.dmpCategories.clear()
      await dataBase.dmpCategories.bulkPut(
        data.dmpCategories.map(c => ({
          ...c,
          title: c.title,
          cachedAt: new Date().toISOString()
        }))
      )

      for (const item of data.motivationalReports) {
        const existing = await dataBase.motivationalReport.where('serverId').equals(item.id).first()
        let localId
        if (existing) {
          await dataBase.motivationalReport.update(existing.id, {
            projectId: String(item.project.id),
            pointId: String(item.tradePoint.id),
            createdAt: item.createDate,
            synced: 2,
            cachedAt: new Date().toISOString(),
          })
          localId = existing.id
        } else {
          localId = await dataBase.motivationalReport.add({
            serverId: item.id,
            projectId: String(item.project.id),
            pointId: String(item.tradePoint.id),
            createdAt: item.createDate,
            synced: 2,
            cachedAt: new Date().toISOString(),
          })
        }

        if (item.motivationalDmp && item.motivationalDmp.length) {
          await this.loadMotivationalDmp(item.motivationalDmp, localId)
        }
      }

      for (const item of data.pointReports) {
        const pointId = String(item.tradePoint.id)

        await dataBase.pointReport.put({
          id: pointId,
          projectId: String(item.project.id),
          pointId: pointId,
          comment: item.comment ?? '',
          reportStatus: item.SEND
            ? { value: 1, title: 'SEND', name: 'SEND' }
            : { value: 0, title: 'NEW', name: 'NEW' },
          createdAt: item.createDate,
          updatedAt: item.createDate,
          synced: 2,
        })

        if (item.reportPhoto?.length) {
          await dataBase.photos.where('reportId').equals(String(pointId)).delete()
          for (const photo of item.reportPhoto) {
            const response = await fetch(config.image(photo.uuid))
            const arrayBuffer = await response.arrayBuffer();
            await dataBase.photos.add({
              reportId: String(pointId),
              reportType: 'point',
              uuid: photo.uuid,
              extension:  photo.extension,
              blob: arrayBuffer,
              synced: 2,
              dmp: photo.dmp,
              offline: false,
              pointId: String(pointId),
              motivational: photo.motivational,
              createdAt:  new Date().toISOString(),
            })
          }
        } else {
          await dataBase.photos.where('reportId').equals(String(pointId)).delete()
        }
      }

      for (const item of data.products) {
        item.product.hasAction = item.hasAction
        item.product.hasReportData = item.hasReportData
        await dataBase.products.put({
          ...item.product,
          pointId: String(item.pointId),
          projectId: String(item.projectId),
          categoryId: String(item.categoryId),
          cachedAt: new Date().toISOString(),
        })

        const key = `${item.product.id}_${item.pointId}`
        item.reportData.presense = item.presense
        await dataBase.productReportData.put({
          id: key,
          productId: String(item.product.id),
          pointId: String(item.pointId),
          projectId: String(item.projectId),
          data: item.reportData,
          synced: 2,
          cachedAt: new Date().toISOString(),
        })

        if (item.reportData?.photo?.length) {
          await dataBase.photos.where('reportId').equals(key).delete()
          for (const photo of item.reportData.photo) {
            try {
              const response = await fetch(config.image(photo.uuid))
              const arrayBuffer = await response.arrayBuffer()
              await dataBase.photos.add({
                reportId: key,
                uuid: photo.uuid,
                extension: photo.extension,
                blob: arrayBuffer,
                synced: 2,
                dmp: photo.dmp,
                pointId: String(item.pointId),
                motivational: photo.motivational,
                createdAt: new Date().toISOString(),
              })
            } catch (e) {
              console.warn(`[prefetchAll] Не удалось скачать фото ${photo.uuid}:`, e)
            }
          }
        } else {
          await dataBase.photos.where('reportId').equals(key).delete()
        }
      }

      for (const projectId of projectIds) {
        await dataBase.projects.update(projectId, {
          prefetchedAt: new Date().toISOString()
        })
      }

      console.log('[DataService] prefetchAll завершён')
    } catch (e) {
      console.error('[DataService] prefetchAll ошибка:', e)
    }
  },

  async deleteMotivationalDmp(motivationalReportId) {
    let motivationalDmps = await dataBase.motivationalDmp.where('localMotivationalReportId').equals(Number(motivationalReportId)).toArray()
    for(let dmp of motivationalDmps) {
      await dataBase.photos.where('reportId').equals(`${dmp.localMotivationalReportId}_${dmp.id}`).delete()
      await dataBase.motivationalDmpReport.where('localDmpId').equals(Number(dmp.id)).delete()
    }
    await dataBase.motivationalDmp.where('localMotivationalReportId').equals(Number(motivationalReportId)).delete()
  },

  async loadMotivationalDmp(motivationalDmp, motivationalReportId) {
    for (let dmp of motivationalDmp) {
      try {
        let existing = await dataBase.motivationalDmp.where('serverId').equals(dmp.id).first()
        if (existing) {
          await dataBase.motivationalDmp.update(existing.id, {
            dmpCategory: dmp.dmpCategory,
            comment: dmp.comment,
            localMotivationalReportId: Number(motivationalReportId),
            serverId: dmp.id,
            synced: 2,
            cachedAt: new Date().toISOString(),
          })
        } else {
          await dataBase.motivationalDmp.add({
            dmpCategory: dmp.dmpCategory,
            comment: dmp.comment,
            localMotivationalReportId: Number(motivationalReportId),
            serverId: dmp.id,
            synced: 2,
            createdAt: new Date().toISOString(),
          })
        }
        let localDmp = await dataBase.motivationalDmp.where('serverId').equals(Number(dmp.id)).first()
        await dataBase.motivationalDmpReport.where('localDmpId').equals(Number(localDmp.id)).delete()
        await dataBase.photos.where('reportId').equals(`${localDmp.localMotivationalReportId}_${localDmp.id}`).delete()
        if(dmp.motivationalDmpReports && dmp.motivationalDmpReports.length) {
          for(const report of dmp.motivationalDmpReports) {
            if(new Date(report.sendDate).getDate() == new Date().getDate()) {
              await dataBase.motivationalDmpReport.add({
                localDmpId: Number(localDmp.id),
                dmpCategory: report.dmpCategory,
                synced: 2,
                cachedAt: new Date().toISOString()
              })
              if(report.reportPhotos && report.reportPhotos.length) {
                for (const photo of report.reportPhotos) {
                  const response = await fetch(config.image(photo.uuid))
                  const arrayBuffer = await response.arrayBuffer();
                  await dataBase.photos.add({
                    reportId: `${localDmp.localMotivationalReportId}_${localDmp.id}`,
                    uuid: photo.uuid,
                    extension:  photo.extension,
                    blob: arrayBuffer,
                    synced: 2,
                    dmp: photo.dmp,
                    pointId: String(report.pointId),
                    motivational: photo.motivational,
                    createdAt:  new Date().toISOString(),
                  })
                }
              }
            }
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
  },

  async getProjects() {
    if (!store.state.user.offlineMode) {
      try {
        let data = await projectService.getMyProjects()
        const role = localStorage.getItem('role')
        if(role == "MERCH") {
          let projects = await dataBase.projects.toArray()
          data.forEach(p => {
            const existing = projects.find(el => el.id === p.id)
            p.prefetchedAt = existing ? existing.prefetchedAt : null
          })
          await dataBase.projects.clear()
          await dataBase.projects.bulkPut(
            data.map(p => {
              const existing = projects.find(l => l.id === p.id)
              return {
                ...p,
                prefetchedAt: existing ? existing.prefetchedAt : null,
                cachedAt:     new Date().toISOString()
              }
            })
          )
        }
        

        return data
      } catch (e) {
        console.log(e)
        console.warn('[DataService] getProjects: нет ответа, берём кэш')
      }
    }
    return dataBase.projects.toArray()
  },

  async loadProject(projectId) {
    if(store.state.user.offlineMode) {
      try {
        let project = await projectService.loadProject(projectId)
        const role = localStorage.getItem('role')
        if(role == "MERCH") {
          const existing = await dataBase.projects.get(Number(projectId))
          await dataBase.projects.put({ ...project,
            prefetchedAt: existing ? existing.prefetchedAt : null,
            cachedAt: new Date().toISOString() 
          })
        }
        return project
      } catch(e) {
        console.warn('[DataService] loadProject: нет ответа, берём кэш')
      }
    }
    return dataBase.projects.get(Number(projectId))
  },

  // ─── СЕТИ ───────────────────────────────────────────────────────

  async getNetworks(projectId) {
    if (!store.state.user.offlineMode) return await networkService.loadMyNetwork(projectId)
    return dataBase.networks.where('projectId').equals(Number(projectId)).toArray()
  },

  async loadNetwork(networkId, projectId) {
    if (!store.state.user.offlineMode) {
      try {
        let network = await networkService.loadNetwork(networkId)
        return network
      } catch (e) {
        console.warn('[DataService] loadNetwork: нет ответа, берём кэш', e)
      }
    }
    return dataBase.networks.where('[id+projectId]').equals([Number(networkId), Number(projectId)]).first()
  },

  // ─── ТОЧКИ ──────────────────────────────────────────────────────

  async getPoints(projectId, networkId) {
    if (!store.state.user.offlineMode) return await tradepointService.getmytradepoints(projectId, networkId)
    return dataBase.points.where('[networkId+projectId]').equals([Number(networkId), Number(projectId)]).toArray()
  },

  async loadTradePoint(pointId) {
    if (!store.state.user.offlineMode) {
      try {
        let tradePoint = await tradepointService.loadPoint(pointId)
        return tradePoint
      } catch (e) {
        console.warn('[DataService] getTradePoint: нет ответа, берём кэш')
      }
    }
    
    return dataBase.points.get(Number(pointId))
  },

  // ─── Категории ───────────────────────────────────────────────────

  async getCategories(pointId, projectId) {
    if (!store.state.user.offlineMode) {
      try {
        let data = await categoryService.getpointcategories(pointId, projectId)
        return data
      } catch (e) {
        console.warn('[DataService] getProducts: нет ответа, берём кэш')
      }
    }
    return dataBase.categories.where('pointId').equals(Number(pointId)).sortBy('name')
  },

  async loadCategory(categoryId, pointId) {
    if (!store.state.user.offlineMode) {
      try {
        let category = await categoryService.loadCategory(categoryId)
        return category
      } catch (e) {
        console.warn('[DataService] getProducts: нет ответа, берём кэш')
      }
    }
    return dataBase.categories.where('[id+pointId]').equals([Number(categoryId), Number(pointId)]).first()
  },

  // ─── ПРОДУКТЫ ───────────────────────────────────────────────────

  async getActionProducts(projectId, pointId) {
    if (!store.state.user.offlineMode) {
      try {
        let data = await productService.loadPointActionProducts(projectId, pointId)
        return data
      } catch (e) {
        console.warn('[DataService] getProducts: нет ответа, берём кэш')
      }
    }
    let products = await dataBase.products.where('[categoryId+pointId]').equals(["a", String(pointId)]).sortBy('name')
    if(products && products.length) {
      for(const product of products) {
        const key = `${product.id}_${product.pointId}`
        let reportData = await dataBase.productReportData.get(key)
        product.reportData = reportData.data
        let field = reportData.data.reportFieldWithData.find(el => el.name == "Остаток")
        if(field && field.value != null) {
          product.hasReportData = true
        }
      }
    }
    return products
  },

  async getPointProducts(projectId, pointId, categoryId) {
    if (!store.state.user.offlineMode) {
      try {
        let data = await productService.loadPointProducts(projectId, pointId, categoryId)
        return data
      } catch (e) {
        console.warn('[DataService] getPointProducts: нет ответа, берём кэш')
      }
    }
    let products = await dataBase.products.where('[categoryId+pointId]').equals([String(categoryId), String(pointId)]).sortBy('name')
    if(products && products.length) {
      for(const product of products) {
        const key = `${product.id}_${product.pointId}`
        let reportData = await dataBase.productReportData.get(key)
        product.reportData = reportData.data
        let field = reportData.data.reportFieldWithData.find(el => el.name == "Остаток")
        if(field && field.value != null) {
          product.hasReportData = true
        }
        
      }
    }
    return products
  },

  async countPointActionProducts(projectId, pointId) {
    if(!store.state.user.offlineMode) {
      try {
        let data = await productService.countPointActionProducts(projectId, pointId)
        return data
      } catch (e) {
        console.warn('[DataService] countPointActionProducts: нет ответа, берём кэш')
      }
    }
    return dataBase.products.where('[categoryId+pointId]').equals(["a", String(pointId)]).count()
  },


  async getProductReportData(projectId, pointId, productId) {
    if (!store.state.user.offlineMode) {
      try {
        let data = await productService.getProductReportData(projectId, pointId, productId)
        return data
      } catch (e) {
        console.log(e);
        console.warn('[DataService] getProductReportData: нет ответа, берём кэш')
      }
    }
    const cached = await dataBase.productReportData.get(`${productId}_${pointId}`)
    if(cached) {
      cached.data.photo = []
      const photos = await dataBase.photos.where('reportId').equals(String(cached.id)).toArray()
      if(photos.length) {
        for (const photo of photos) {
          cached.data.photo.push(photo)
        }
      }
      
    }
    return cached ? cached.data : null
  },


  async hasUnsyncedReport() {
    let totalReportData = await dataBase.productReportData.where('synced').equals(0).count()
    let totalPointReports = await dataBase.pointReport.where('synced').equals(0).count()
    let totalDmpReports = await dataBase.motivationalDmpReport.where('synced').equals(0).count()
    let unsyncedMotivationalDmp = await dataBase.motivationalDmp.where('synced').equals(0).count()
    const total = totalReportData + totalPointReports + totalDmpReports + unsyncedMotivationalDmp
    return total > 0 ? true : false
  }
}